import { all } from "redux-saga/effects";

import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import LocationsSaga from "./locations/saga";
import UsersSaga from "./users/saga";
import PackagesSaga from "./packages/saga";
import DevicesSaga from "./devices/saga";
import RentalsSaga from "./rentals/saga";
import PowerBankSaga from "./powerbanks/saga";
import ReportsSaga from "./reports/saga";
import ComplaintsSaga from "./complaints/saga";
import WithdrawSaga from "./withdraws/saga";
import CorporatesSaga from "./corporate/saga";
import ReferelCodeSaga from "./referel-code/saga";
import WattiSaga from "./watti/saga";
import OffersSaga from "./offers/saga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    layoutSaga(),
    WattiSaga(),
    OffersSaga(),
    UsersSaga(),
    LocationsSaga(),
    CorporatesSaga(),
    ReferelCodeSaga(),
    PackagesSaga(),
    DevicesSaga(),
    RentalsSaga(),
    PowerBankSaga(),
    ReportsSaga(),
    ComplaintsSaga(),
    WithdrawSaga(),
  ]);
}
